(() => {
  if (window.__raShippingCountdownColorInitialised) return;
  window.__raShippingCountdownColorInitialised = true;

  const GREEN = '#168f4d';
  const RED_ZONE_START = 35;

  const colorForPercent = (percent) => {
    if (percent > RED_ZONE_START) return GREEN;
    const ratio = Math.max(0, Math.min(1, percent / RED_ZONE_START));
    const hue = Math.round(ratio * 120);
    return `hsl(${hue} 75% 40%)`;
  };

  const updateFill = (fill) => {
    const width = Number.parseFloat(fill.style.width || getComputedStyle(fill).width) || 0;
    const track = fill.parentElement;
    let percent = width;

    if (track && !String(fill.style.width).includes('%')) {
      const trackWidth = track.getBoundingClientRect().width;
      const fillWidth = fill.getBoundingClientRect().width;
      percent = trackWidth > 0 ? (fillWidth / trackWidth) * 100 : 0;
    }

    fill.style.setProperty('background', colorForPercent(percent), 'important');
  };

  const refresh = (root = document) => {
    root.querySelectorAll?.('[id^="ra-shipping-countdown-"] [data-shipping-progress]').forEach(updateFill);
  };

  const start = () => {
    refresh();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.target.matches?.('[data-shipping-progress]')) {
          updateFill(mutation.target);
        }
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) refresh(node);
        });
      });
    });

    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['style']
    });

    window.setInterval(() => refresh(), 1000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => refresh(event.target));
})();
